var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.000000, -7021.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer/desktop",
    transform: "translate(0.000000, 6607.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email-11",
    transform: "translate(84.000000, 414.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2421875,0 L1.7578125,0 C0.789765625,0 0,0.78890625 0,1.7578125 L0,13.4765625 C0,14.4421875 0.78625,15.234375 1.7578125,15.234375 L18.2421875,15.234375 C19.2078125,15.234375 20,14.448125 20,13.4765625 L20,1.7578125 C20,0.7921875 19.21375,0 18.2421875,0 Z M17.9994531,1.171875 L10.0372656,9.13410156 L2.00621094,1.171875 L17.9994531,1.171875 Z M1.171875,13.2339063 L1.171875,1.99488281 L6.81558594,7.59019531 L1.171875,13.2339063 Z M2.00050781,14.0625 L7.64777344,8.41523438 L9.6265625,10.3770312 C9.855625,10.6041406 10.2252734,10.6033984 10.4533984,10.3752344 L12.3828125,8.44582031 L17.9994922,14.0625 L2.00050781,14.0625 Z M18.828125,13.2338672 L13.2114453,7.6171875 L18.828125,2.00046875 L18.828125,13.2338672 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d23f5e47bd68a55f975b434c4fe60382.svg";
export { ForwardRef as ReactComponent };